module.exports = __webpack_public_path__ + "static/media/logo-old.3ef7a4be.png";